import { ToolsPage } from 'src/views/abi/tools'
import pathMap from 'src/paths/pathMap'

class AbiToolsRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_TOOLS_PATH,
        component: ToolsPage
      }
    ]
  }
}

export default AbiToolsRoute
